import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const SellerProfileSkeleton = () => {
  return (
    <div className="main-content-container seller-profile-page">
      {/* Banner con logo e informazioni */}
      <div className="seller-profile-banner">
        <div className="skeleton-seller-profile-banner-img skeleton-loader"></div>
        <div className="seller-profile-banner-content">
          <div className="skeleton-seller-profile-logo skeleton-loader"></div>
          <div className="skeleton-seller-profile-info">
            <div className="skeleton-seller-profile-title skeleton-loader"></div>
            <div className="skeleton-seller-profile-description skeleton-loader"></div>
            <div className="skeleton-seller-profile-visit-btn skeleton-loader"></div>
          </div>
        </div>
      </div>

      {/* Menu di navigazione */}
      <div className="seller-profile-tabs">
        <div className="skeleton-seller-profile-tab skeleton-loader"></div>
        <div className="skeleton-seller-profile-tab skeleton-loader"></div>
        <div className="skeleton-seller-profile-tab skeleton-loader"></div>
        <div className="skeleton-seller-profile-tab skeleton-loader"></div>
      </div>

      <div className="tab-content">
        {/* Tab Prodotti */}
        <div className="tab-pane active" id="products">
          <div className="seller-profile-products-row">
            {/* Sidebar filtri (desktop) */}
            <div className="seller-profile-sidebar-desktop">
              <div className="skeleton-seller-profile-sidebar skeleton-loader"></div>
            </div>
            
            {/* Griglia/lista prodotti */}
            <div className="seller-profile-products-main">
              {/* Toolbar mobile */}
              <div className="products-toolbar toolbar-mobile-custom">
                <div className="toolbar-mobile-row1">
                  <div className="skeleton-seller-profile-filter-btn skeleton-loader"></div>
                  <div className="skeleton-seller-profile-search-input skeleton-loader"></div>
                </div>
                <div className="toolbar-mobile-row2">
                  <div className="skeleton-seller-profile-sort-pill skeleton-loader"></div>
                  <div className="skeleton-seller-profile-view-toggle skeleton-loader"></div>
                </div>
              </div>
              
              {/* Toolbar desktop */}
              <div className="products-toolbar toolbar-desktop-only">
                <div className="skeleton-seller-profile-search-input skeleton-loader"></div>
                <div className="skeleton-seller-profile-sort-label skeleton-loader"></div>
                <div className="skeleton-seller-profile-sort-pill skeleton-loader"></div>
                <div className="skeleton-seller-profile-view-toggle skeleton-loader"></div>
              </div>
              
              {/* ProductGrid con skeleton integrato */}
              <div className="product-grid-container">
                <div className="product-grid">
                  <div className="product-grid-grid">
                    {[...Array(8)].map((_, index) => (
                      <div key={index} className="product-grid-item product-grid-item-grid">
                        <div className="skeleton-product-card skeleton-loader"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerProfileSkeleton; 